export async function sendEmail({ serviceId, templateId, userId, templateParams }) {
  try {
    const res = await fetch("https://api.emailjs.com/api/v1.0/email/send", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        service_id: serviceId,
        template_id: templateId,
        user_id: userId,
        template_params: templateParams,
      }),
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }
    return { success: true };
  } catch (err) {
    return { success: false, error: err.message };
  }
}
